
















import {Component} from '@/shared/component';
import {AbstractSearchVue} from '@/components/Abstract/AbstractSearchVue';

import InputSearchEntity from '@/components/Input/SearchEntity.vue';
import CrudTransporteurFilter from '@/components/Crud/Transporteur/Filter.vue';
import CrudTransporteurListForSelect from '@/components/Crud/Transporteur/ListForSelect.vue';

@Component({
	components: {
		CrudTransporteurFilter,
		CrudTransporteurListForSelect,
		InputSearchEntity,
	}
})
export default class CrudTransporteurSearch extends AbstractSearchVue {
	private filterComponent = CrudTransporteurFilter;
	private listComponent = CrudTransporteurListForSelect;
}
